// @flow
import { AuthActionTypes } from './constants';

type AuthAction = { type: string, payload: {} | string };

// common success
export const authApiResponseSuccess = (actionType: string, data: any): AuthAction => ({
    type: AuthActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const authApiResponseError = (actionType: string, error: string): AuthAction => ({
    type: AuthActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const loginUser = (username: string, password: string): AuthAction => ({
    type: AuthActionTypes.LOGIN_USER,
    payload: { username, password },
});

export const loginUserInfotools = (credentials: any): AuthAction => ({
    type: AuthActionTypes.LOGIN_USER_INFOTOOLS,
    payload: credentials,
});

export const logoutUser = (): AuthAction => ({
    type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

export const logoutUserInfotools = (): AuthAction => ({
    type: AuthActionTypes.LOGOUT_USER_INFOTOOLS,
    payload: {},
});

export const signupUser = (fullname: string, email: string, password: string): AuthAction => ({
    type: AuthActionTypes.SIGNUP_USER,
    payload: { fullname, email, password },
});

export const forgotPassword = (username: string): AuthAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD,
    payload: { username },
});

export const forgotPasswordChange = (username: string): AuthAction => ({
    type: AuthActionTypes.FORGOT_PASSWORD_CHANGE,
    payload: { username },
});

export const updateDestinationInToken = (data: any): AuthAction => ({
    type: AuthActionTypes.UPDATE_DESTINATION_IN_TOKEN,
    payload: data,
});

export const resetAuth = (): AuthAction => ({
    type: AuthActionTypes.RESET,
    // type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

export const resetAuthInfotools = (): AuthAction => ({
    type: AuthActionTypes.RESET_INFOTOOLS,
    payload: {},
});

export const updateAvatar=(avatar:string): AuthAction => ({
    type: AuthActionTypes.UPDATE_AVATAR,
    payload:{avatar}
})
